import * as gs from "@ivanlog/gs";
import { CmpHeaderBase } from "./tmpls";
import { App } from "../App";
import { ClassesTags } from "../libs/ClassesTags";

export class CmpHeader extends CmpHeaderBase {

    private _connectText="";
    constructor() {
        super();
        this.ctrls.btnMenu.onclick=()=>this.ctrls.blockMobileNav.flipClass(ClassesTags.Active);
        //this.ctrls.btnConnect.disable();
        this._connectText=this.ctrls.btnConnect.text;

        this.ctrls.btnConnect.onclick=async ()=>{
           
            this.ctrls.btnConnect.disable();
            if (App.chain.account)
            {
                await App.chain.disconnectAsync();
            } else
            {
                const result = await App.chain.tryConnectAsync();
            }
            this.ctrls.btnConnect.enable();
        }
    }

    public async initAsync()
    {
        App.chain.onChangeAccount.addHandler(async()=>{
            await this.refreshConnectionAsync();
        });
        await this.refreshConnectionAsync();
    }

    public async refreshConnectionAsync()
    {
        if (App.chain.account) 
        {
            const wallet = App.chain.account
            //this.ctrls.btnConnect.disable();
            this.ctrls.btnConnect.text=wallet.slice(0,6)+"..."+wallet.slice(-4);
        } else
        {
            //this.ctrls.btnConnect.enable();
            this.ctrls.btnConnect.text = this._connectText;
        }
        const chainId = await App.chain.getChainIdAsync();
        if (chainId === App.chain.chainId || chainId === undefined)
        {
            this.ctrls.tagPLS.show();
            this.ctrls.tagWrongChain.hide();
        } else
        {
            this.ctrls.tagPLS.hide();
            this.ctrls.tagWrongChain.show();
        }
    }
}
